export default "__VITE_ASSET__DVVMgdWd__"